import { configPerms } from "../../const/configPerms";
import { PermsTable } from "../../interfaces/Permissions";
// Un "from" inconnu (app non declaree dans configPerms, ou state pas encore
// initialise) renvoyait undefined et faisait planter le rendu de la page
// Permissions (page blanche) : on retombe sur une liste vide.
export const getConfigPerms = (from) => configPerms[from] ?? [];
export const buildRight = (from, defaultValue) => {
    const appConfigPerms = getConfigPerms(from);
    const map = appConfigPerms.map(i => {
        return [i, defaultValue];
    });
    const perm = Object.fromEntries(map);
    const specPerm = specificRight(from);
    return { ...perm, ...specPerm };
};
export const buildDefaultRight = (from, defaultRight) => {
    const appConfigPerms = getConfigPerms(from);
    const map = appConfigPerms.map(i => {
        return [i, !!defaultRight[i]];
    });
    const perm = Object.fromEntries(map);
    return perm;
};
const specificRight = (from) => {
    const specific = {};
    if (getConfigPerms(from).includes(PermsTable.AllowShareSynchro)) {
        specific.allowShareSynchro = false;
    }
    return specific;
};
